/* eslint-disable react/no-this-in-sfc */
/* eslint-disable no-underscore-dangle */
/* eslint-disable object-shorthand */
/* eslint-disable func-names */
/* eslint-disable react/jsx-key */
/* eslint-disable react/button-has-type */
import CaseImage from '@nect/ui/asset/img/case.png';
import { Color } from '@nect/ui/theme/color';
import Downshift from 'downshift';
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';

import { useCombinedRefs } from '../../hook/use-combine-ref';
import { IconNavigationCloseOutline } from '../icon/auto/navigation-close-outline';
import { IconNavigationDownOutline } from '../icon/auto/navigation-down-outline';
import { IconNavigationLeftOutline } from '../icon/auto/navigation-left-outline';
import { InputState } from '../input';
import DropdownStyled from './dropdown.styled';

export interface IDropdownItem {
    value: string;
    id?: number | string;
    icon?: React.ReactNode;
}

export interface IDropdownProps {
    /**
    Input state
     */
    state?: InputState;

    /**
    Input Placeholder
    */
    placeholder?: string;

    /**
    Label to show when no result is found
    */
    notFoundLabel?: string;

    /**
    If the field is cleanable
     */
    isCleanable?: boolean;

    /**
    Input name
     */
    name?: string;

    /**
    Dropdown Items
    */
    items: IDropdownItem[];

    /**
    on change handler
    */
    onChange: React.ChangeEventHandler<HTMLInputElement>;

    /**
      Input's on blur event
      */
    onBlur?: React.FocusEventHandler<HTMLInputElement>;
}

// @TODO Rewrite this component
const stateReducer = (state: any, changes: any) => {
    if (changes?.type === '__autocomplete_click_button__') {
        return { ...state };
    }

    // Prevents clicking outside to close the view on mobile
    if (
        [
            '__autocomplete_mouseup__',
            '__autocomplete_touchend__',
            '__autocomplete_blur_input__',
            '__autocomplete_blur_button__',
        ].includes(changes?.type) &&
        window.innerWidth <= 767 // @TODO Improve breakpoints
    ) {
        // eslint-disable-next-line no-param-reassign
        delete changes.isOpen;
        return { ...state, ...changes };
    }

    // Prevents flickering on clear button on mobile
    if (changes?.type === '___customClear') {
        return { ...state, ...changes, isOpen: true, customClear: true };
    }

    // Makes arrow icon work on desktop
    if (changes?.type === '___toggleOpen') {
        return {
            ...state,
            ...changes,
            isOpen: !state.isOpen,
            customOpen: true,
        };
    }

    if (changes?.type === '___customOpen') {
        return { ...state, ...changes, customOpen: true };
    }

    // @TODO When something is selected and you click outside to close it's require to click twice to close, fix this.
    // if (
    //     changes?.type === '__autocomplete_mouseup__' &&
    //     changes?.highlightedIndex === null
    // ) {
    //     return { ...state, ...changes, customOpen: false, isOpen: false };
    // }

    if (changes?.type === '__autocomplete_mouseup__' && state.customOpen) {
        // eslint-disable-next-line no-param-reassign
        delete changes.isOpen;
        // eslint-disable-next-line no-param-reassign
        delete changes.inputValue;
        return { ...state, ...changes, customOpen: false };
    }

    if (
        changes?.type === '__autocomplete_click_button__' &&
        state.customClear
    ) {
        return { ...state, ...changes, isOpen: true, customClear: false };
    }

    return { ...state, ...changes };
};

export const Dropdown = React.forwardRef<HTMLInputElement, IDropdownProps>(
    (
        {
            placeholder,
            name,
            state = 'default',
            items,
            notFoundLabel = 'We didn’t find what you’re searching for.',
            onChange,
            onBlur,
            isCleanable = false,
        }: IDropdownProps,
        ref,
    ) => {
        const containerRef = useRef<any>(null);
        const inputRef = useRef<HTMLInputElement>(null);
        const combinedInputRef = useCombinedRefs(ref, inputRef);
        const [inputValueState, setInputValueState] = useState('');
        const [selectedItemState, setSelectedItemState] =
            useState<IDropdownItem | null>(null);

        useEffect(() => {
            (combinedInputRef.current as any)._value = (
                combinedInputRef.current as any
            ).value;
            Object.defineProperty(combinedInputRef.current, 'value', {
                get: function () {
                    return this._value;
                },
                set: function (v) {
                    if (this._value === '') {
                        const itemFound = items.find(
                            (item) => item.value === v,
                        );
                        setSelectedItemState(itemFound || null);
                        setInputValueState(v);
                    }

                    this._value = v;
                },
            });
        }, []);

        const blurInput = () => (combinedInputRef as any)?.current?.blur();

        return (
            <Downshift
                ref={containerRef}
                onChange={(selectedItem: IDropdownItem | null) => {
                    blurInput();
                    const newInputField = !selectedItem
                        ? ''
                        : selectedItem.value;
                    setInputValueState(newInputField);
                    setSelectedItemState(selectedItem);
                    if (combinedInputRef?.current) {
                        (combinedInputRef.current as any).value = newInputField;
                        onChange({
                            type: 'change',
                            target: combinedInputRef.current,
                        } as unknown as ChangeEvent<HTMLInputElement>);
                    }
                }}
                stateReducer={stateReducer}
                itemToString={(item) => (item ? item.value : '')}
                inputValue={inputValueState}
                selectedItem={selectedItemState}
            >
                {({
                    getInputProps,
                    getItemProps,

                    getMenuProps,
                    getToggleButtonProps,
                    isOpen,
                    inputValue,
                    highlightedIndex,
                    selectedItem,
                    getRootProps,
                    openMenu,
                    closeMenu,
                    selectItem,
                    setState,
                }) => {
                    const filteredItems =
                        selectedItem?.value === inputValue
                            ? items
                            : items.filter(
                                  (item) =>
                                      !inputValue ||
                                      item?.value
                                          ?.toLowerCase()
                                          ?.startsWith(
                                              inputValue?.toLowerCase(),
                                          ),
                                  // @TODO Handle accents
                              );
                    return (
                        <DropdownStyled.ContainerStyled isOpen={isOpen}>
                            {isOpen && (
                                <DropdownStyled.HeaderStyled>
                                    <IconNavigationLeftOutline
                                        size={24}
                                        onClick={() => {
                                            blurInput();
                                            closeMenu();
                                        }}
                                        onKeyUp={(e) => {
                                            const key = e.key || e.keyCode;
                                            if (
                                                key === 'Escape' ||
                                                key === 'Esc' ||
                                                key === 27
                                            ) {
                                                blurInput();
                                                closeMenu();
                                            }
                                        }}
                                        // role="button"
                                        // ariaLabel="Close Dropdown"
                                        // tabIndex={0}
                                    />
                                    Back
                                </DropdownStyled.HeaderStyled>
                            )}
                            <DropdownStyled.BoxStyled
                                radius="XS"
                                $isOpen={isOpen}
                                $state={state}
                                {...getRootProps(
                                    { refKey: 'innerRef' },
                                    { suppressRefError: true },
                                )}
                            >
                                <DropdownStyled.InputStyled
                                    {...(getInputProps({
                                        placeholder,
                                        onFocus: () =>
                                            setState({
                                                type: '___customOpen' as any,
                                                isOpen: true,
                                            }),
                                        onClick: () =>
                                            setState({
                                                type: '___customOpen' as any,
                                                isOpen: true,
                                            }),
                                        name,
                                        onChange: (
                                            event: ChangeEvent<HTMLInputElement>,
                                        ) => {
                                            onChange(event);
                                            setInputValueState(
                                                event?.target?.value || '',
                                            );
                                        },
                                        onBlur,
                                        ref: combinedInputRef,
                                    }) as any)}
                                />

                                {(selectedItem ||
                                    (window.innerWidth <= 767 && isOpen)) &&
                                isCleanable ? (
                                    <DropdownStyled.ToggleButtonStyled
                                        {...getToggleButtonProps({
                                            onClick: () =>
                                                selectItem(null as any, {
                                                    type: '___customClear' as any,
                                                }),
                                        })}
                                        aria-label="Clear dropdown"
                                    >
                                        <IconNavigationCloseOutline
                                            size={24}
                                            color={Color.grey400}
                                        />
                                    </DropdownStyled.ToggleButtonStyled>
                                ) : (
                                    <DropdownStyled.ToggleButtonStyled
                                        {...getToggleButtonProps({
                                            onClick: () => {
                                                if (isCleanable) {
                                                    selectItem(null as any, {
                                                        type: '___toggleOpen' as any,
                                                    });
                                                } else {
                                                    setState({
                                                        type: '___customOpen' as any,
                                                        isOpen: true,
                                                    });
                                                }
                                                return false;
                                            },
                                        })}
                                        aria-label="Toggle dropdown"
                                    >
                                        <IconNavigationDownOutline
                                            flipVertically={isOpen}
                                            size={24}
                                        />
                                    </DropdownStyled.ToggleButtonStyled>
                                )}
                            </DropdownStyled.BoxStyled>
                            {isOpen && (
                                <DropdownStyled.ListContainerStyled
                                    isNotFoundState={!filteredItems?.length}
                                >
                                    <ul {...getMenuProps()}>
                                        {!filteredItems?.length && (
                                            <DropdownStyled.EmptyStyled>
                                                <img
                                                    src={CaseImage as any}
                                                    alt="Not found"
                                                    width={48}
                                                    height={40}
                                                />
                                                {notFoundLabel}
                                            </DropdownStyled.EmptyStyled>
                                        )}

                                        {filteredItems.map((item, index) => (
                                            <DropdownStyled.ListItemStyled
                                                {...{
                                                    ...getItemProps({
                                                        key: item.value,
                                                        index,
                                                        item,
                                                    }),
                                                    isHighlighted:
                                                        highlightedIndex ===
                                                        index,
                                                    isSelected:
                                                        JSON.stringify(
                                                            selectedItem,
                                                        ) ===
                                                        JSON.stringify(item),
                                                }}
                                            >
                                                {item.icon}
                                                <span>{item.value}</span>
                                            </DropdownStyled.ListItemStyled>
                                        ))}
                                    </ul>
                                </DropdownStyled.ListContainerStyled>
                            )}
                        </DropdownStyled.ContainerStyled>
                    );
                }}
            </Downshift>
        );
    },
);

Dropdown.displayName = 'Dropdown';
